import React from 'react'
import Link from 'components/Link'
import * as ProductIcons from '../ProductIcons'

type LinkGridProps = {
    links: { name: string; to: string; description: string; icon?: string }[]
}

export const LinkGrid: React.FC<LinkGridProps> = ({ links }) => {
    return (
        <ul className="m-0 grid gap-[1px] p-0 md:grid-cols-2">
            {links?.length > 0 &&
                links.map((link) => {
                    const Icon = link.icon && ProductIcons[link.icon]
                    return (
                        <li key={link.name} className="list-none">
                            <Link
                                to={link.to}
                                key={link.name}
                                disablePrefetch
                                className="group relative flex items-center space-x-3 rounded-sm px-2 py-2 hover:top-[-.5px] hover:scale-[1.01]
                            hover:bg-gray-accent-light active:top-[0.25px] active:scale-[.99] dark:hover:bg-gray-accent-dark"
                            >
                                {Icon && (
                                    <Icon className="grou-hover:bg-gray-accent/50 mt-1 h-10 w-10 shrink-0 rounded-sm bg-gray-accent-light p-2 text-primary group-hover:bg-gray-accent/50 dark:bg-gray-accent-dark dark:text-primary-dark lg:mt-0.5" />
                                )}
                                <div>
                                    <h3 className="m-0 text-base font-semibold text-red">{link.name}</h3>
                                    {/* {link.description} */}
                                </div>
                            </Link>
                        </li>
                    )
                })}
        </ul>
    )
}
